import Vue from "vue"
import Vuex from "vuex"
import toast from "./toast"
import news from "./news"
import users from "./users"
import { deleteCookie, setCookie } from "@/helpers/customizeCookie.js"

import en from "@/plugins/locales/en.json"
import vi from "@/plugins/locales/vi.json"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: "",
      reconnectError: false,
      loggedInUser: {},
      isLogging: false,
      errorLogging: "",
      isReconnecting: false,
    },
    auth: {
      isAuth: false,
      user: null,
      token: null,
    },
    showLogoutPopup: false,
    // Dialog nhập OTP step-up 2FA (xem helpers/mfaStepUp.js)
    showMfaStepUp: false,
    // true: bắt buộc xác thực ngay sau login (không cho huỷ)
    mfaStepUpMandatory: false,
    sideBarAppMini: false,
    sideBarContactMini: false,
    listImagePreview: [],
    listUserReadOnly: [],
    listUserReadOnlyName: "",
    selectedImgIndex: 0,
    currentRightSideActive: 1,
    currentRightSideTab: 0,
    selectedUser: {},
    selectedUserGroup: {},
    splitMark: "$#%8$H%",
    currentLanguage: "vi", // vi | en
  },
  mutations: {
    setLang(state, payload) {
      state.currentLanguage = payload
    },
    setCurrentRightSideTab(state, number) {
      state.currentRightSideTab = number
    },
    setCurrentRightSideActive(state, number) {
      state.currentRightSideActive = number
    },
    setSelectedUser(state, record) {
      state.selectedUser = record
    },
    setSelectedUserGroup(state, record) {
      state.selectedUserGroup = record
    },
    setListImagePreview(state, payload) {
      state.listImagePreview = payload
    },
    setSelectedImgIndex(state, payload) {
      state.selectedImgIndex = payload
    },
    SET_LISTUSER_READONLY_POPUP(state, payload) {
      state.listUserReadOnly = [...payload]
    },
    SET_LISTUSER_READONLY_POPUPNAME(state, payload) {
      state.listUserReadOnlyName = payload
    },
    SET_USER_LOGGEDIN(state, payload) {
      state.auth = { ...payload }
    },
    HOTSET_USER(state, payload) {
      state.auth = { ...state.auth, user: payload }
    },
    SET_LOGOUT_USER(state) {
      deleteCookie("token")
      state.auth = { isAuth: false, user: null, token: null }
    },
    SET_LOGOUT_POPUP(state, payload) {
      state.showLogoutPopup = payload
    },
    SET_MFA_STEP_UP_VISIBLE(state, payload) {
      state.showMfaStepUp = payload
    },
    SET_MFA_STEP_UP_MANDATORY(state, payload) {
      state.mfaStepUpMandatory = payload
    },
    SET_AUTH_TOKEN(state, payload) {
      if (state.auth) {
        state.auth = { ...state.auth, token: payload }
      }
    },
    setCurrentToken(state, payload) {
      // localStorage.setItem("token", payload)
      setCookie("token", payload, 30)
      state.currentToken = payload
    },
    setSidebarMini(state, payload) {
      state.sideBarAppMini = payload
    },
    setSidebarContactMini(state, payload) {
      state.sideBarContactMini = payload
    },
    // SOCKET HANDLER
    SOCKET_ONOPEN(state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      if (state.socket.isReconnecting) {
        state.socket.isReconnecting = false
      }
      Vue.prototype.$socket.send(
        JSON.stringify({
          msg: "connect",
          version: "1",
          support: ["1"],
        }),
      )
    },
    SOCKET_ONCLOSE(state) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      state.socket.isReconnecting = true
      console.info(state.socket, count, "reconnect socket")
      if (count >= 3) {
        // window.location.href = '/';
      }
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true
    },
    //
  },
  getters: {
    isAuth: (state) => {
      return state.auth.isAuth
    },
    token: (state) => {
      return state.auth.token
    },
    userFromAuth: (state) => {
      if (!state.auth.user) {
        return {}
      }
      return state.auth.user
    },
    userPermissions: (state) => {
      if (!state.auth.user) {
        return []
      }
      return state.auth.user.application_access_permissions || []
    },
    sysLanguage: (state) => {
      // languageObj
      if (state.currentLanguage === "en") {
        return en
      }
      return vi
    },
  },
  actions: {},
  modules: { toast, news, users },
})
